const ROLES = {
  1: { name: 'Super Admin', value: 'super_admin' },
  2: { name: 'Admin', value: 'admin' },
  3: { name: 'Employee', value: 'employee' },
};

export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const EMPLOYEE = 3;

export default ROLES;
